import React from 'react'
import { Typography, Form, Select, Col, InputNumber } from 'antd'
import { tipologie, piani, extra } from '../assets/constants'
import _ from 'lodash'
import ExtraRadioGroup from './extraRadioGroup'
import MaskedInput from 'react-text-mask'
import createNumberMask from 'text-mask-addons/dist/createNumberMask'
import { useState } from 'react'
const { Title, Text } = Typography

const defaultMaskOptions = {
  prefix: '',
  suffix: ` mq`,
  includeThousandsSeparator: true,
  thousandsSeparatorSymbol: '.',
  allowDecimal: true,
  decimalSymbol: ',',
  decimalLimit: 1, // how many digits allowed after the decimal
  integerLimit: 3,
  allowNegative: false,
  allowLeadingZeroes: false,
}

const ExtraInfo = (props) => {
  const sizeMask = createNumberMask(defaultMaskOptions)
  const [extraValues, setExtraValues] = useState(extra)
  const tipologia = _.get(props.formValue, 'tipologia')
  const handleSetOnForm = (selectedValues) => {
    const updatedExtra = extraValues.map((item) => {
      if (item.value === 'ascensore') {
        return {
          ...item,
          label: selectedValues.includes('ascensore')
            ? 'Senza ascensore'
            : 'Ascensore',
        }
      }
      return item
    })

    setExtraValues(updatedExtra)
    props.addValue({ extra: selectedValues })
    props.form.setFieldsValue({ extra: selectedValues })
  }

  return (
    <>
      <Title>
        Dicci di più
        {tipologia === '4' ? ' sulla tua ' : ' sul tuo '}
        {_.lowerCase(_.get(tipologie, `[${parseInt(tipologia)}]`))}
      </Title>
      <Col xs={24} sm={24} md={24} lg={12}>
        <Form.Item name="size" rules={[{ required: true }]}>
          <MaskedInput
            mask={sizeMask}
            inputMode="numeric"
            suffix="mq"
            defaultValue={props.formValue.size}
            placeholder={`Inserisci la superficie dell'alloggio (mq)`}
            className="ant-input-affix-wrapper ant-input-affix-wrapper-lg"
          />
        </Form.Item>
      </Col>
      <Col xs={24} sm={24} md={24} lg={12}>
        <Form.Item name="piano" rules={[{ required: true }]}>
          <InputNumber
            placeholder="A che piano si trova"
            size="large"
            inputMode="numeric"
            min={-2}
            max={100}
            defaultValue={props.formValue.floors}
            className="w-full"
          />
        </Form.Item>
      </Col>
      <Col xs={24} sm={24} md={24} lg={12}>
        <Form.Item name="building_floors">
          <InputNumber
            placeholder="Inserisci il numero di piani dell'edificio"
            size="large"
            inputMode="numeric"
            min={-2}
            max={100}
            defaultValue={props.formValue.building_floors}
            className="w-full"
          />
        </Form.Item>
      </Col>
      <Text className="font-semibold">L'appartamento ha</Text>
      <Form.Item name="extra">
        <ExtraRadioGroup
          values={extraValues}
          defaultValue={_.get(props, 'formValue.extra')}
          setOnForm={handleSetOnForm}
          name="extra"
          multiple
        />
      </Form.Item>
    </>
  )
}

export default ExtraInfo
